import { works } from '@/mocks/works';
import SectionTitle from '@/components/base/SectionTitle';
import WorkCard from '@/components/feature/WorkCard';

export default function FeaturedWorks() {
  const featured = works.slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="max-w-6xl mx-auto px-4 py-14 md:px-8 md:py-20">
        <SectionTitle
          eyebrow="Featured Works"
          title="作品精选推荐"
          desc="精选深田咏美的电影、电视剧与纪录片作品，点击查看完整资料与相关资讯。"
          linkText="查看全部作品"
          linkTo="/works"
        />
        <div
          className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-3"
          data-product-shop
        >
          {featured.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}